import {Select} from "antd";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectUser, setChartBudgetGroup} from "../../redux/features/userSlice";
import {useSetChartsParamsMutation} from "../../redux/api/userPreferencesApiSlice";

export default function BudgetGroupSelect() {
    const dispatch = useDispatch()
    const budgetGroup = useSelector(selectUser).preferences?.charts_params?.budget_group
    const budgetGroupOptions = useSelector(selectUser).budget_groups

    const [updateChartsParams] = useSetChartsParamsMutation()

    return (budgetGroupOptions.length > 0 ? <Select options={budgetGroupOptions}
                                                    labelInValue
                                                    virtual={false}
                                                    value={budgetGroup}
                                                    dropdownMatchSelectWidth={false}
                                                    onSelect={(option: any) => {
                                                        dispatch(setChartBudgetGroup({
                                                            label: option.label,
                                                            value: option.value
                                                        }))
                                                        updateChartsParams({
                                                            budget_group: {
                                                                label: option.label,
                                                                value: option.value
                                                            }
                                                        })
                                                    }}
                                                    style={{width: 120, textAlign: 'center'}}/> : null)

}